import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            gcTime: 30_000,
            refetchOnWindowFocus: false,
            retry: false,
            staleTime: 30_000,
        },
    },
});
